import { render, staticRenderFns } from "./CustomTable.vue?vue&type=template&id=6efd98c8&scoped=true&"
import script from "./CustomTable.vue?vue&type=script&lang=ts&"
export * from "./CustomTable.vue?vue&type=script&lang=ts&"
import style0 from "./CustomTable.vue?vue&type=style&index=0&id=6efd98c8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6efd98c8",
  null
  
)

export default component.exports